import { Component, Inject, OnInit } from '@angular/core';
import { EmployeeArticle, EmployeeArticleVerbose } from '../../models/article.model';
import { TranslateService } from '@ngx-translate/core';
import { ArticlesService } from '../../services/articles.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-article-dialog',
  templateUrl: './article-dialog.component.html',
  styleUrls: ['./article-dialog.component.scss']
})
export class ArticleDialogComponent implements OnInit {
  article: EmployeeArticle;
  articleVerbose: EmployeeArticleVerbose;
  articleImage$: any;
  loading: boolean;

  constructor(
      public translate: TranslateService,
      private articlesService: ArticlesService,
      private dialogRef: MatDialogRef<ArticleDialogComponent>,
      @Inject(MAT_DIALOG_DATA) data,
      private sanitizer: DomSanitizer
    ){
      this.article = data.article;
      if (this.article.titleImage) {
        this.articleImage$ = this.articlesService.getEmployeeArticleFile(this.article.id, this.article.titleImage.id);
      }
    }

  ngOnInit(): void {
    this.getArticleDetails();
  }

  getArticleDetails() {
    this.loading = true;

    this.articlesService.getEmployeeArticle(this.article.id)
      .subscribe(
        {
          next: (v) => {
            this.articleVerbose = v;
            this.loading = false;
          },
          error: (e) => {
            this.loading = false;
          }
        }
      );
  }

  getSafeContent(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.articleVerbose.content);
  }

  // close() {
  //   this.dialogRef.close();
  // }

}
